import Loadable from 'react-loadable';

export default Loadable({
  loader: () =>
    import(/* webpackChunkName: "app-landing" */ './AsyncSellYourArtRoute.js'),
  loading: () => null
});
